// extracted by css-extract-rspack-plugin
export default {"wrapper":"_9a248f4","link":"_16d2dbc7"};